import type { SVGProps } from "react"
import React from "react"

export const MinusIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.54883 9.99998C2.54883 9.76986 2.73538 9.58331 2.96549 9.58331H17.0322C17.2623 9.58331 17.4488 9.76986 17.4488 9.99998C17.4488 10.2301 17.2623 10.4166 17.0322 10.4166H2.96549C2.73538 10.4166 2.54883 10.2301 2.54883 9.99998Z"
      fill={fill}
    />
  </svg>
)
